<template>
	<div class="home">
		<section class="master header">
			<div class="content">
				<div class="summary">
					<component :is="href('/home').content" />
					<router-link class="action" to="/about">{{ translation.menu.about }}</router-link>
					<router-link class="action-link" to="/contacts">{{ translation.menu.contacts }}</router-link>
				</div>
			</div>
			<div class="image">
				<figure>
					<img :src="href('/home').meta.image" :alt="href('/home').meta.summary">
				</figure>
			</div>
		</section>
		<section class="master">
			<div class="image">
				<figure>
					<img :src="href('/home/sales-funnel').meta.image" :alt="href('/home/sales-funnel').meta.summary">
				</figure>
			</div>
			<div class="content">
				<div class="summary">
					<component :is="href('/home/sales-funnel').content" />
					<details :open="isDetailsOpened">
						<summary>{{ href('/home/sales-funnel/details').meta.summary }}</summary>
						<component :is="href('/home/sales-funnel/details').content" />
					</details>
				</div>
			</div>
		</section>

		<section class="highlights">
			<div class="full">
				<component :is="href('/use-cases').content" />
			</div>
			<div class="content">
				<section class="column summary" v-for="highlight in href('/use-cases/*')" :key="highlight.meta.href">
					<figure class="pictogram">
						<img :src="highlight.meta.image" :alt="highlight.meta.title">
					</figure>
					<component :is="highlight.content" />
				</section>
			</div>
		</section>

		<section class="master">
			<div class="content">
				<div class="summary">
					<component :is="href('/home/traffic-insights').content" />
					<details :open="isDetailsOpened">
						<summary>{{ href('/home/traffic-insights/details').meta.summary }}</summary>
						<component :is="href('/home/traffic-insights/details').content" />
					</details>
				</div>
			</div>
			<div class="image">
				<figure>
					<img :src="href('/home/traffic-insights').meta.image" :alt="href('/home/traffic-insights').meta.summary">
				</figure>
			</div>
		</section>
		<section class="master">
			<div class="image">
				<figure>
					<img :src="href('/home/conversions').meta.image" :alt="href('/home/conversions').meta.summary">
				</figure>
			</div>
			<div class="content">
				<div class="summary">
					<component :is="href('/home/conversions').content" />
					<details :open="isDetailsOpened">
						<summary>{{ href('/home/conversions/details').meta.summary }}</summary>
						<component :is="href('/home/conversions/details').content" />
					</details>
				</div>
			</div>
		</section>
		<section class="leaflet">
			<div class="content">
				<component :is="href('/home/experience').content" />
				<router-link to="/about"><span><font-awesome-icon icon="long-arrow-alt-right"/></span>&nbsp;{{ href('/home/experience').meta.action }}</router-link>
			</div>
		</section>
	</div>
</template>

<style lang="less" scoped>
@import url('~@/assets/views/home.less');
</style>

<script>
import hreflang from '@/lib/hreflang'

export default {
	name: 'Home',
	mixins: [ hreflang ],
	components: {
	},
	computed: {
		isDetailsOpened: () => {
			return window.innerHeight < window.innerWidth && window.innerHeight > 1000
		}
	},
	created() {
		this.document(require('documents/en/home/home.md'), 'en')
		this.document(require('documents/en/home/home-details.md'), 'en')
		this.document(require('documents/en/home/sales-funnel.md'), 'en')
		this.document(require('documents/en/home/sales-funnel-details.md'), 'en')
		this.document(require('documents/en/home/traffic-insights.md'), 'en')
		this.document(require('documents/en/home/traffic-insights-details.md'), 'en')
		this.document(require('documents/en/home/conversions.md'), 'en')
		this.document(require('documents/en/home/conversions-details.md'), 'en')
		this.document(require('documents/en/home/conversions.md'), 'en')
		this.document(require('documents/en/home/experience.md'), 'en')
		this.document(require('documents/en/use-cases/use-cases.md'), 'en')
		this.document(require('documents/en/use-cases/front-desk.md'), 'en')
		this.document(require('documents/en/use-cases/call-center.md'), 'en')
		this.document(require('documents/en/use-cases/storefront.md'), 'en')
	}
}
</script>
